import React from "react";
var __jsx = React.createElement;
import Review from "./components/Review/Review";
import { useTranslation } from "@i18n";
import BoxLoading from "@componentsShared/placeholders/BoxLoading/BoxLoading";
import stl from "./ReviewsPage.module.css";
var ReviewsPage = function ReviewsPage(_ref) {
  var loading = _ref.loading,
    feedbackList = _ref.feedbackList,
    scrollLoadingAreaRef = _ref.scrollLoadingAreaRef;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement("div", {
    className: stl.ratingPageContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.allUserratingContainer
  }, /*#__PURE__*/React.createElement("h1", null, t("customer_feedback", {
    ns: "web_common"
  })), /*#__PURE__*/React.createElement("div", {
    id: "feedback_item_view",
    className: "w-100"
  }, /*#__PURE__*/React.createElement("div", {
    ref: scrollLoadingAreaRef,
    className: stl.MURallContent
  }, !feedbackList.length && loading ? /*#__PURE__*/React.createElement(BoxLoading, {
    divHeight: 147,
    numberOfLoaders: 5
  }) : feedbackList.map(function (item, i) {
    return /*#__PURE__*/React.createElement(Review, {
      key: i,
      name: item.name,
      date: item.date,
      city: item.city,
      review: item.comment,
      rate: item.rate,
      carName: item.car_title,
      carYear: item.car_year,
      carCondition: item.car_condition
    });
  }), feedbackList.length && loading && /*#__PURE__*/React.createElement(BoxLoading, {
    className: stl.loadBox,
    numberOfLoaders: 5
  })))));
};
export default ReviewsPage;